import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, ArrowRight } from "lucide-react";
import logo from "../assets/logo.jpeg";

const footerLinks = {
  "Platform": [
    { label: "About Us", to: "/about" },
    { label: "How It Works", to: "/how-it-works" },
    { label: "Energy Packages", to: "/packages" },
    { label: "Community", to: "/community" },
    { label: "FAQ", to: "/faq" },
  ],
  "Partners": [
    { label: "Affiliate Network", to: "/affiliate" },
    { label: "Targets & Rewards", to: "/targets" },
    { label: "Dashboard Preview", to: "/dashboard-preview" },
    { label: "Wallet & Payout", to: "/wallet" },
  ],
  "Energy": [
    { label: "Wind Energy", to: "/wind-energy" },
    { label: "Solar Energy", to: "/solar-energy" },
    { label: "Security", to: "/security" },
  ],
  "Legal": [
    { label: "Terms & Conditions", to: "/terms#terms" },
    { label: "Privacy Policy", to: "/terms#privacy" },
    { label: "Risk Disclosure", to: "/terms#risk" },
    { label: "Compliance", to: "/security" },
  ],
};

const Footer = () => (
  <footer className="bg-navy-deep border-t border-border">
    <div className="container mx-auto px-4 py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
        {/* Brand with logo */}
        <div className="lg:col-span-2">
          <Link to="/" className="flex items-center gap-3 mb-4 group">
            <img
              src={logo}
              alt="AeroVolt"
              className="h-20 w-auto rounded-lg object-contain group-hover:scale-105 transition-transform duration-300"
            />
            {/* Optional text if needed */}
            {/* <div>
              <span className="font-display text-base font-bold tracking-wider block leading-none">AEROVOLT</span>
              <span className="text-[9px] text-muted-foreground tracking-[0.2em] uppercase">Energy</span>
            </div> */}
          </Link>
          <p className="text-muted-foreground text-sm leading-relaxed mb-5 max-w-sm">
            Powering the Future. Empowering Global Partners. Sustainable energy infrastructure connecting investors with operational wind and solar assets across 45+ countries.
          </p>
          <div className="space-y-2 text-sm text-muted-foreground">
            <span className="flex items-center gap-2"><Mail className="w-4 h-4 text-primary" /> info@aerovolt.energy</span>
            <span className="flex items-center gap-2"><Phone className="w-4 h-4 text-primary" /> +44 20 7946 0958</span>
            <span className="flex items-center gap-2"><MapPin className="w-4 h-4 text-primary" /> Canary Wharf, London, UK</span>
          </div>
        </div>

        {/* Links */}
        {Object.entries(footerLinks).map(([title, links]) => (
          <div key={title}>
            <h4 className="font-display text-xs font-semibold tracking-[0.25em] uppercase text-primary mb-4">{title}</h4>
            <div className="flex flex-col gap-2.5">
              {links.map((l) => (
                <Link key={l.label} to={l.to} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  {l.label}
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* CTA Bar */}
      <div className="mt-12 p-6 rounded-2xl glass-card flex flex-col md:flex-row items-center justify-between gap-4">
        <div>
          <h4 className="font-display text-lg font-bold mb-1">Ready to start your energy journey?</h4>
          <p className="text-sm text-muted-foreground">Join 32,000+ global partners in sustainable energy infrastructure.</p>
        </div>
        <Link to="/packages" className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary text-primary-foreground font-semibold text-sm hover:bg-primary/90 transition-all glow-box whitespace-nowrap">
          Get Started <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="mt-8 pt-6 border-t border-border">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <p>© 2026 AeroVolt Energy Ltd. All rights reserved. Registered in England & Wales.</p>
          <p className="text-center md:text-right">⚠️ Renewable projects involve market risks. Distributions are performance-based and not guaranteed.</p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;